module.exports = __webpack_public_path__ + "static/media/figures.f011f04d.png";